import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./AppShell.css";

export default function AppShell({ children, me, serverTime, onLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const owner = me?.access_level === "owner" || me?.is_platform_admin;
  const links = [
    ["/clients-jobs", "Home"],
    ["/clients/management", "Clients"],
    ["/estimates", "Estimates"],
    ["/invoices", "Invoices"],
    ["/products-services", "Products & Services"],
    ["/integrations/thumbtack/leads", "Leads"],
    ["/integrations/thumbtack", "Integrations"],
    ["/reports", "Reports"],
    ...(owner ? [["/reports/books", "Books"]] : []),
    ...(owner ? [["/employees", "Employees"]] : []),
    ["/profile", "Settings"],
  ];


  return (
    <div className="jt-shell">
      <header className="jt-topbar">
        <div className="jt-topbar-inner">
          <NavLink to="/clients-jobs" className="jt-brand">
            <div className="jt-brand-mark">JT</div>
            <div>
              <div className="jt-brand-title">JobTelesis</div>
              <div className="jt-brand-sub">
                {me?.tenant_name || "Workspace"}
              </div>

              {serverTime?.server_time_pacific && (
                <div className="jt-brand-server-time">
                  Server: {new Date(serverTime.server_time_pacific).toLocaleString()}
                </div>
              )}
            </div>
          </NavLink>

          <div
            className="jt-topbar-actions"
            onMouseEnter={() => setMenuOpen(true)}
            onMouseLeave={() => setMenuOpen(false)}
          >
            <button
              type="button"
              className="jt-menu-button"
              onClick={() => setMenuOpen((v) => !v)}
            >
              ☰ Menu
            </button>

            <button type="button" className="jt-logout" onClick={onLogout}>
              Logout
            </button>
          </div>
        </div>

        {menuOpen && (
          <nav
            className="jt-mobile-menu jt-menu-panel"
            onMouseEnter={() => setMenuOpen(true)}
            onMouseLeave={() => setMenuOpen(false)}
          >
            {links.map(([to, label]) => (
              <NavLink
                key={to}
                to={to}
                className="jt-mobile-link"
                onClick={() => setMenuOpen(false)}
              >
                {label}
              </NavLink>
            ))}

            <button type="button" className="jt-mobile-logout" onClick={onLogout}>
              Logout
            </button>
          </nav>
        )}
      </header>

      <main className="jt-main">
        {children}
      </main>
    </div>
  );
}
